// extracted by mini-css-extract-plugin
export default {"paper_dialog":"TransportHistoriesPopup_paper_dialog__g8V7N","decktop":"TransportHistoriesPopup_decktop__v4DPg"};